import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { GeneralConfirmationComponent } from '../../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { CheckForErrorsMessageComponent } from '../../../../shared-components/guards/check-for-errors/check-for-errors-message/check-for-errors-message.component';
import { StaffSearchComponent } from '../../../../shared-components/staff-search/staff-search.component';
import { Staff } from '../../../../shared-components/staff-search/staff.model';
import { Enrollment } from '../../../../shared-components/student/enrollment.model';
import { StudentService } from '../../../../shared-components/student/student.service';
import { YearService } from '../../../../shared-components/year/year.service';
import { SpedCollectionStudentToTeamMember } from '../../../student-document-home/sped-student-document-cards/sped-student-document-cards.model';
import { SpedStudentDocumentCardsService } from '../../../student-document-home/sped-student-document-cards/sped-student-document-cards.service';
import { FormWithinDocumentsService } from '../../form-within-documents.service';
import { SpedTeamMemberUpdate } from '../../formwithin-document-modal';
import { HeaderModelValuePipe } from './pipes/header-model-value.pipe';

@Component({
  selector: 'app-manage-team',
  templateUrl: './manage-team.component.html',
  styles: [],
  providers: [HeaderModelValuePipe]
})
export class ManageTeamComponent implements OnInit {
  columnToDisplay = ['TeamMemberName', 'IsCreator', 'Action'];
  columnToDisplayForm: string[] = [];
  spedCollectionToStudentId: number;
  teamMembers: SpedCollectionStudentToTeamMember[] = [];
  tylerMatData = new TylerMatTableDataSource();
  studentCollectionTeamMemberPermission = [];
  collectionName = '';
  status = '';
  typeSelected = '';
  studentEnrolledSchools: Enrollment[] = [];
  schoolIds: number[] = [];
  warningDialog: MatDialogRef<CheckForErrorsMessageComponent>;

  constructor(private matDialogRef: MatDialogRef<ManageTeamComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialog: MatDialog,
    private spedStudentDocumentCradsService: SpedStudentDocumentCardsService,
    private formWithinDocumentsService: FormWithinDocumentsService,
    private headerModelValue: HeaderModelValuePipe,
    private studentService: StudentService,
    private yearService: YearService) { }

  ngOnInit() {
    this.loadTeamMemberData();
    this.getStudentEnrolledSchools();
  }

  loadTeamMemberData() {
    this.getTeamMemberName();
    this.getSpedStudentCollectionTeamMember();
  }

  getStudentEnrolledSchools() {
    this.studentService.getStudentEnrollments(this.studentService.selectedStudent.Id, this.yearService.defaultYear.Id).subscribe(enrolledSchool => {
      this.studentEnrolledSchools = enrolledSchool;
      this.studentEnrolledSchools.forEach(school => {
        this.schoolIds.push(school.SchoolId);
      });
    });
  }

  getSpedStudentCollectionTeamMember() {
    this.formWithinDocumentsService.getSpedStudentCollectionTeamMemberPermission(this.spedCollectionToStudentId).subscribe(data => {
      this.studentCollectionTeamMemberPermission = data != '' ? JSON.parse(data) : [];
      const colToDisplay = this.studentCollectionTeamMemberPermission != null && this.studentCollectionTeamMemberPermission != undefined ? Object.keys(this.studentCollectionTeamMemberPermission[0]) : [];
      this.columnToDisplayForm = ['FormName'];
      colToDisplay.forEach(columnName => {
        if (columnName != 'FormName' && columnName != 'TemplateVersionId' && columnName != 'FormVersion') {
          this.columnToDisplayForm.push(columnName);
        }
      });
    });
  }

  getTeamMemberName() {
    this.spedStudentDocumentCradsService.spedCollectionStudentToTeamMember(this.spedCollectionToStudentId, false).subscribe(result => {
      this.teamMembers = result;
      this.tylerMatData = new TylerMatTableDataSource(this.teamMembers);
      this.tylerMatData.data = this.teamMembers;
    });
  }

  addStaffClick() {
    const staffSearchDialog = this.dialog.open(StaffSearchComponent, {
      data: {
        searchAndSelect: false,
        pageName: 'manageTeam',
        schoolIds: this.schoolIds
      },
      height: '100vh',
      width: '100vw',
      maxHeight: '100vh',
      maxWidth: '100vw',
      disableClose: true,
    });
    staffSearchDialog.componentInstance.selectedSchoolId = this.studentEnrolledSchools.find(x => x.PrimaryEnrollment == true).SchoolId;
    staffSearchDialog.afterClosed().subscribe((selectedStaff: Staff) => {
      if (selectedStaff) {
        if (this.teamMembers.filter(x => x.TeamMemberId == selectedStaff.UserId).length == 0) {
          this.formWithinDocumentsService.saveTeamMember(this.spedCollectionToStudentId, selectedStaff.StaffId, true).subscribe(() => {
            this.getTeamMemberName();
            this.getSpedStudentCollectionTeamMember();
          });
        }
      }
    });
  }

  deleteClick(teamMember: SpedCollectionStudentToTeamMember) {
    const generalConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
      disableClose: true
    });
    generalConfirmDialog.componentInstance.headerLabel = 'Delete Maintain Team';
    generalConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to delete' + ' ' + teamMember.TeamMemberName + '?';
    generalConfirmDialog.componentInstance.okButtonLabel = 'Delete';
    generalConfirmDialog.afterClosed().subscribe(result => {
      if (result == true) {
        this.deleteTeamMember(teamMember.TeamMemberId);
      }
    });
  }

  deleteTeamMember(teacherUserId: number) {
    this.formWithinDocumentsService.deleteSpedTeamMember(this.spedCollectionToStudentId, teacherUserId).subscribe(() => {
      this.loadTeamMemberData();
    });
  }

  selectedTypeChange(header: string, value: string) {
    this.studentCollectionTeamMemberPermission.forEach(obj => {
      if (value == 'True') {
        obj[header] = 'True';
      }
      if (value == 'False') {
        obj[header] = 'False';
      }
    });
  }

  saveClick() {
    const data: SpedTeamMemberUpdate[] = [];
    this.teamMembers.forEach(ele => {
      let template = '';
      template = '<MyData>';
      this.studentCollectionTeamMemberPermission.forEach(obj => {
        template += '<MyItem><lngTemplateID>' + obj['TemplateVersionId'] + '</lngTemplateID><blnIsEdit>' + (obj[ele.TeamMemberId] == 'True' ? '1' : '0') + '</blnIsEdit></MyItem>';
      });
      template += '</MyData>';
      const templatevalue = template;
      data.push({ CollectionToStudentId: this.spedCollectionToStudentId, TeacherUserId: ele.TeamMemberId, Template: templatevalue });
    });
    this.saveData(data);
    this.matDialogRef.close('save');
  }

  saveData(data: SpedTeamMemberUpdate[]) {
    this.formWithinDocumentsService.spedUpdateTeamMember(data).subscribe(() => { });
  }

  selectMode(columnName: string) {
    this.typeSelected = '';
    this.typeSelected = this.headerModelValue.transform('', columnName, this.studentCollectionTeamMemberPermission);
  }

  CancelClick() {
    this.matDialogRef.close();
  }

  closeClick() {
    this.warningDialog = this.dialog.open(CheckForErrorsMessageComponent, {
      disableClose: true,
      data: {
        errors: []
      }
    });
    this.warningDialog.componentInstance.dialogBox = this.warningDialog;
    this.warningDialog.afterClosed().subscribe(result => {
      switch (result) {
        case 1: {
          this.saveClick();
          break;
        }
        case 0: {
          this.matDialogRef.close();
          break;
        }
        case -1: {
          this.warningDialog.close();
          break;
        }
        default: {
          break;
        }
      }
    });
  }

}